import { ChartAxisLabel } from '/src/lib/types';

/**
 * Axis Label
 */

export type AxisLabelProps = ChartAxisLabel;

export class AxisLabel implements AxisLabelProps {
  axis?: any; // D3 Axis
  text = '';
  position?: string[];
  classes?: string[];
  styles?: string[];
  element: any; // D3 Element

  constructor(axis?: any, text = '', position?: string[], classes?: string[], styles?: string[]) {
    if (!axis || !text) return;
    this.axis = axis;
    this.text = text;
    this.position = position ? position : undefined;
    this.classes = classes ? classes : undefined;
    this.styles = styles ? styles : undefined;

    this.element = this.axis.append('text');

    if (this.position) {
      for (const item in this.position) {
        this.element.attr(item, this.position[item]);
      }
    }
    if (this.classes) this.element.attr('class', classes);
    if (this.styles) {
      if (this.styles.length) {
        for (const style in this.styles) {
          this.element.style(style, this.styles[style]);
        }
      }
    }

    this.element.text(text);
  }
}
